import styled from 'styled-components';

import { Box } from '@hivebrite/design-system/Box';

import VideoPlayer from 'hb-react/shared/components/VideoPlayer';

interface AttachedVideoFile {
  file_url: string;
  id: number;
}

interface AttachedVideosProps {
  attachedVideos: Array<AttachedVideoFile>;
}

const AttachedVideos = ({ attachedVideos }: AttachedVideosProps) =>
  attachedVideos.map((file: any) => (
    <Wrapper key={file.id}>
      <VideoPlayer url={file.file_url} width="100%" height="100%" />
    </Wrapper>
  ));

export default AttachedVideos;

const Wrapper = styled(Box).attrs(() => ({
  mt: 3,
  display: 'block',
}))`
  aspect-ratio: 16/9;
`;
